import {environment} from "./environments/environment";
import {enableProdMode, importProvidersFrom} from "@angular/core";
import {bootstrapApplication} from '@angular/platform-browser';
import {provideHttpClient, withInterceptors, withInterceptorsFromDi} from '@angular/common/http';
import {provideRouter} from '@angular/router';
import {provideAuth0, authHttpInterceptorFn} from '@auth0/auth0-angular';
import {AppComponent} from './app/app.component';
import {routes} from './app/app.routes';
import {BrowserAnimationsModule} from "@angular/platform-browser/animations";
import {provideAnimationsAsync} from "@angular/platform-browser/animations/async";
import {fr_FR, provideNzI18n} from "ng-zorro-antd/i18n";
import {IconModule} from "./app/shared/components/icon/icon.module";
import {QuillModule} from "ngx-quill";
import {registerLocaleData} from "@angular/common";
import fr from '@angular/common/locales/fr';
import {AkitaNgDevtools} from "@datorama/akita-ngdevtools";

registerLocaleData(fr);

if (environment.production) {
  enableProdMode();
}

bootstrapApplication(AppComponent, {
  providers: [
    provideRouter(routes),
    provideHttpClient(
      withInterceptorsFromDi(),
      withInterceptors([authHttpInterceptorFn])
    ),
    provideAuth0({
      domain: environment.auth0.domain,
      clientId: environment.auth0.clientId,
      authorizationParams: {
        audience: environment.auth0.audience,
        redirect_uri: window.location.origin + '/callback',
      },
      cacheLocation: 'localstorage',
      useRefreshTokens: true,
      httpInterceptor: {
        allowedList: [
          {
            uri: `${environment.origin}/bff/*`,
            tokenOptions: {
              authorizationParams: {audience: environment.auth0.audience}
            }
          },
          {uri: `${environment.origin}/me`},
          // // ...et en relatif si tu appelles simplement '/me'
          // {uri: '/me'}
        ]
      }
    }),
    provideAnimationsAsync(),
    provideNzI18n(fr_FR),
    importProvidersFrom(
      IconModule,
      QuillModule.forRoot(),
      ...(environment.production ? [] : [AkitaNgDevtools.forRoot()])
    ),
    importProvidersFrom(BrowserAnimationsModule)
  ]
}).catch(err => console.error(err));
